import { CIcon } from '~/icons/types'

export const ciDesktop: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M18.75 2.25H5.25a3 3 0 0 0-3 3V15a3 3 0 0 0 3 3h3v.257a2.249 2.249 0 0 1-.659 1.591l-.621.622a.75.75 0 0 0 .53 1.28h9a.75.75 0 0 0 .53-1.28l-.621-.622a2.249 2.249 0 0 1-.659-1.591V18h3a3 3 0 0 0 3-3V5.25a3 3 0 0 0-3-3Zm1.5 10.5a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-7.5a1.5 1.5 0 0 1 1.5-1.5h13.5a1.5 1.5 0 0 1 1.5 1.5v7.5Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'desktop',
  type: 'solid'
}
